/* Explicit project-save requests use Klaviyo's public browser endpoints.
   https://developers.klaviyo.com/en/reference/create_client_profile
   https://developers.klaviyo.com/en/reference/create_client_event
   HTTP 202 confirms acceptance, never email delivery. No tracking cookie required. */
(function(root,factory){if(typeof module==='object'&&module.exports)module.exports=factory();else root.FMTRecoveryClient=factory();})(typeof window!=='undefined'?window:this,function(){
 'use strict';
 function create(options){
  var person=null,send=options.fetch,site=options.siteId;
  if(!/^[A-Za-z0-9]{6}$/.test(site))throw new Error('Invalid public site ID');
  async function post(path,data){
   var controller=new AbortController(),timer=setTimeout(function(){controller.abort();},8000);
   try{var response=await send('https://a.klaviyo.com/client/'+path+'?company_id='+encodeURIComponent(site),{method:'POST',credentials:'omit',headers:{'Content-Type':'application/vnd.api+json','revision':'2026-07-15'},body:JSON.stringify({data:data}),signal:controller.signal});
    if(response.status!==202){var error=new Error('The email service could not save this request. Please try again, or copy your project link.');error.code='rejected';throw error;}
    return true;
   }finally{clearTimeout(timer);}
  }
  return {
   identify:async function(input){
    var attributes={email:input.email,properties:{}};
    Object.keys(input).forEach(function(key){if(key==='first_name'||key==='last_name')attributes[key]=input[key];else if(key!=='email')attributes.properties[key]=input[key];});
    await post('profiles',{type:'profile',attributes:attributes});person={email:input.email};return {success:true};
   },
   track:async function(name,properties){
    if(!person)throw new Error('Save your details first.');
    return post('events',{type:'event',attributes:{properties:properties,unique_id:properties.requestId,metric:{data:{type:'metric',attributes:{name:name}}},profile:{data:{type:'profile',attributes:person}}}});
   }
  };
 }
 return {create:create};
});
